import React from 'react';
import { Check, Download, Smartphone, BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-8 md:pt-14 pb-10 md:pb-14 px-5 bg-cream-100 texture-paper overflow-hidden" data-id="element-108">
      <div className="max-w-5xl mx-auto" data-id="element-109">
        {/* Top trust badge */}
        <div className="flex justify-center mb-6" data-id="element-110">
          <div className="inline-flex items-center gap-2 bg-olive-50 text-olive-700 px-4 py-1.5 rounded-full text-xs font-medium border border-olive-100" data-id="element-111">
            <span className="w-1.5 h-1.5 rounded-full bg-olive-500" data-id="element-112"></span>
            Guía digital de bienestar natural
          </div>
        </div>

        {/* Headline */}
        <h1 className="text-center font-serif font-medium text-3xl md:text-5xl lg:text-6xl leading-[1.1] text-ink-900 mb-5 max-w-3xl mx-auto" data-id="element-113">
          Más de{' '}
          <span className="italic text-olive-600" data-id="element-114">300 remedios naturales</span>{' '}
          de la abuela
        </h1>

        {/* Subtitle */}
        <p className="text-center text-base md:text-lg text-ink-700 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-115">
          Una guía práctica con recetas, infusiones y soluciones naturales
          fáciles de preparar con ingredientes que ya tenés en casa.
        </p>

        {/* Product image */}
        <a href="https://impulsodigital.vip/cart/44742359646294:1" className="block mb-7 md:mb-10 group" data-id="element-116">
          <div className="relative max-w-sm mx-auto" data-id="element-117">
            <div className="absolute inset-0 bg-olive-200/40 blur-3xl rounded-full" data-id="element-118"></div>
            <img src="https://cdn.magicpatterns.com/uploads/fWKo2t3hijFnJB6rDmF5TH/hf_20260327_220519_0b0f6238-3b57-4318-999a-2c6531e204a0.webp" alt="Más de 300 Remedios Naturales de la Abuela — Guía digital" className="relative w-full rounded-2xl shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-119" />
          </div>
        </a>

        {/* Quick value bullets */}
        <div className="max-w-md mx-auto mb-6 md:mb-8 space-y-2.5" data-id="element-120">
          {['Más de 300 remedios organizados por síntomas', 'Ingredientes simples y accesibles', 'Incluye 10 guías digitales de regalo', 'Acceso inmediato desde cualquier dispositivo'].map((bullet, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-121">
              <div className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-olive-100 flex items-center justify-center" data-id="element-122">
                <Check className="w-3 h-3 text-olive-700" strokeWidth={3} data-id="element-123" />
              </div>
              <span className="text-sm md:text-base text-ink-800 font-medium" data-id="element-124">
                {bullet}
              </span>
            </div>)}
        </div>

        {/* Price block */}
        <div className="text-center mb-6" data-id="element-125">
          <p className="text-sm text-ink-600 mb-1" data-id="element-126">
            Precio normal <span className="line-through" data-id="element-127">$49.990</span>
          </p>
          <div className="flex items-baseline justify-center gap-2" data-id="element-128">
            <span className="text-xs font-medium text-olive-600 uppercase tracking-wider" data-id="element-129">
              Hoy
            </span>
            <span className="text-4xl md:text-5xl font-serif font-semibold text-ink-900" data-id="element-130">
              $19.990
            </span>
            <span className="text-sm text-ink-600 font-medium" data-id="element-131">ARS</span>
          </div>
        </div>

        {/* CTA */}
        <CTAButton subtext="Pago seguro · Acceso inmediato · Descarga digital" data-id="element-132" />

        {/* Trust line */}
        <div className="mt-7 md:mt-10 flex items-center justify-center gap-6 md:gap-8 text-ink-600" data-id="element-133">
          <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-134">
            <Download className="w-4 h-4" data-id="element-135" />
            <span data-id="element-136">Acceso inmediato</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-ink-500" data-id="element-137"></div>
          <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-138">
            <Smartphone className="w-4 h-4" data-id="element-139" />
            <span data-id="element-140">Celular y PC</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-ink-500" data-id="element-141"></div>
          <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-142">
            <BookOpen className="w-4 h-4" data-id="element-143" />
            <span data-id="element-144">PDF digital</span>
          </div>
        </div>
      </div>
    </section>;
}